const lastIndex = array => array.length - 1;
export default lastIndex;